<template>
  <div class="vz-menu">
    <transition>
      <div class="vz-menu-overlay" v-show="open" @click.stop="closeMenu">
        <nav class="vz-menu-content">
          <div class="vz-menu-close" @click.stop="closeMenu">
            <i class="ic-x"></i><span>Close menu</span>
          </div>
          <ul class="vz-menu-links">
            <template v-for="item in items">
              <li
                class="vz-menu-links-item vz-has-children"
                v-if="itemHasChildren(item)"
                :class="['vz-menu-links-item-type-' + item.type]"
              >
                <span
                  class="vz-menu-item-label"
                  :class="{ 'vz-expanded': submenu === item.items }"
                  @click.stop="toggleSubmenu(item)"
                >
                  {{ item.label }}
                  <i class="ic-chevron-down vz-ic"></i>
                </span>
                <ul
                  class="vz-submenu"
                  :class="{ 'vz-expanded': submenu === item.items }"
                >
                  <li class="vz-submenu-item" v-for="subitem in item.items">
                    <vz-link
                      class="vz-menu-item-link vz-submenu-item-link"
                      :to="subitem.link"
                      >{{ subitem.label }}</vz-link
                    >
                  </li>
                </ul>
              </li>
              <li
                class="vz-menu-links-item"
                v-else
                :class="['vz-menu-links-item-type-' + item.type]"
              >
                <vz-link class="vz-menu-item-link" :to="item.link">{{
                  item.label
                }}</vz-link>
              </li>
            </template>
          </ul>
        </nav>
      </div>
    </transition>
    <div class="vz-menu-trigger" @click.stop="toggleMenu">
      <i class="ic-menu"></i><span>Menu</span>
    </div>
  </div>
</template>

<script>
import VzLink from 'vsp-web-ui-lib/components/atoms/vz-link.vue';

export default {
  name: 'VzAppMenu',
  emits: ['open', 'close'],
  components: {
    VzLink
  },

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    open: false,
    submenu: null
  }),

  methods: {
    openMenu() {
      this.open = true;
      this.$emit('open');
    },

    closeMenu() {
      this.open = false;
      this.$emit('close');
    },

    toggleMenu() {
      if (this.open) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },

    itemHasChildren(item) {
      return item.items && item.items.length;
    },

    toggleSubmenu(parentItem) {
      this.submenu =
        this.submenu === parentItem.items ? null : parentItem.items;
    }
  }
};
</script>

<style theme="dark-theater" scoped>
.vz-menu-trigger,
.vz-menu-close {
  display: inline-block;
  font-size: 24px;
  cursor: pointer;
  color: #ffffff;
}

.vz-menu-trigger:hover,
.vz-menu-close:hover {
  color: var(--primary-color-over);
}

.vz-menu-trigger:active,
.vz-menu-close:active {
  color: var(--primary-color-active);
}

.vz-menu-trigger > span,
.vz-menu-close > span {
  display: none;
}

.vz-menu-close {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 18px;
}

.vz-menu-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  overflow: hidden;
}

.vz-menu-overlay.v-enter-active,
.vz-menu-overlay.v-leave-active {
  transition-property: opacity;
  transition-duration: 0.3s;
}

.vz-menu-overlay.v-leave-active {
  transition-delay: 0.3s;
}

.vz-menu-overlay.v-enter,
.vz-menu-overlay.v-enter-from,
.vz-menu-overlay.v-leave-to {
  opacity: 0;
}

.vz-menu-overlay.v-leave,
.vz-menu-overlay.v-leave-from,
.vz-menu-overlay.v-enter-to {
  opacity: 1;
}

.vz-menu-content {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 95%;
  max-width: 360px;
  background-color: #0c0c0c;
  padding: 56px 0 0;
  box-shadow: 1px 0 8px rgba(0, 0, 0, 0.57);
  transform: translate(0, 0);
  display: flex;
  align-items: stretch;
}

.vz-menu-overlay.v-enter-active .vz-menu-content,
.vz-menu-overlay.v-leave-active .vz-menu-content {
  transition-property: transform;
  transition-duration: 0.3s;
}

.vz-menu-overlay.v-enter .vz-menu-content,
.vz-menu-overlay.v-enter-from .vz-menu-content,
.vz-menu-overlay.v-leave-to .vz-menu-content {
  transform: translate(-110%, 0);
}

.vz-menu-overlay.v-leave .vz-menu-content,
.vz-menu-overlay.v-leave-from .vz-menu-content,
.vz-menu-overlay.v-enter-to .vz-menu-content {
  transform: translate(0, 0);
}

.vz-menu-links,
.vz-submenu {
  padding: 0;
  margin: 0;
}

.vz-menu-links {
  font-size: 0.82em;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.vz-submenu {
  overflow: hidden;
  max-height: 0;
  transition-property: max-height;
  transition-duration: 0.3s;
}

.vz-submenu.vz-expanded {
  max-height: 1080px;
}

.vz-menu-links-item,
.vz-submenu-item {
  display: block;
}

.vz-menu-links > .vz-menu-links-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.vz-menu-links > .vz-menu-links-item:first-child {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.vz-submenu-item {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  background-color: rgba(255, 255, 255, 0.035);
}

.vz-menu-item-link,
.vz-menu-item-label {
  display: block;
  padding: 16px 32px;
  text-decoration: none;
  border-width: 0;
  transition: background-color 0.3s;
  color: #ffffff;
}

.vz-menu-item-link:active,
.vz-menu-item-label:active {
  background-color: rgba(255, 255, 255, 0.1);
}

.vz-menu-item-label {
  position: relative;
  cursor: pointer;
}

.vz-menu-item-label:hover {
  color: var(--link-color-over);
}

.vz-ic {
  position: absolute;
  top: 50%;
  right: 16px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  transform: translate(0, -50%);
}

.vz-expanded .vz-ic {
  transform: translate(0, -50%) rotateZ(180deg);
}
</style>
















































































































































































